import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  orgUsersList: [],
  orgUserSearchedResult: [],
  loading: false,
  listLoaded: false,
  searchLoading: false,
  error: null
};

const orgAccessSlice = createSlice({
  name: "orgAccess",
  initialState,
  reducers: {
    fetchOrgUsersListRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchOrgUsersListSuccess: (state, action) => {
      state.orgUsersList = action.payload.orgUsersList;
      state.loading = false;
      state.listLoaded = true;
    },
    fetchOrgUsersListError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.listLoaded = true;
    },
    searchOrgUsersRequest: (state) => {
      state.searchLoading = true;
      state.error = null;
    },
    searchOrgUsersSuccess: (state, action) => {
      state.orgUserSearchedResult = action.payload.orgUserSearchedResult;
      state.searchLoading = false;
    },
    searchOrgUsersError: (state, action) => {
      state.orgUserSearchedResult = [];
      state.error = action.payload;
      state.searchLoading = false;
    },
    clearOrgUsersSearch: (state) => {
      state.orgUserSearchedResult = [];
      state.searchLoading = false;
    },
    provideOrgAccessRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    provideOrgAccessSuccess: (state) => {
      state.orgUserSearchedResult = [];
      state.loading = false;
    },
    provideOrgAccessError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    removeOrgUserAccessRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    removeOrgUserAccessSuccess: (state, action) => {
      const { communityId } = action.payload;
      state.orgUsersList = state.orgUsersList.filter(
        (user) => String(user.communityId) !== String(communityId),
      );
      state.loading = false;
    },
    removeOrgUserAccessError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  fetchOrgUsersListRequest,
  fetchOrgUsersListSuccess,
  fetchOrgUsersListError,
  searchOrgUsersRequest,
  searchOrgUsersSuccess,
  searchOrgUsersError,
  clearOrgUsersSearch,
  provideOrgAccessRequest,
  provideOrgAccessSuccess,
  provideOrgAccessError,
  removeOrgUserAccessRequest,
  removeOrgUserAccessSuccess,
  removeOrgUserAccessError,
} = orgAccessSlice.actions;

export default orgAccessSlice.reducer;
